import React from 'react'
import toast from 'react-hot-toast'
import { useSearchStore } from '../../../store/jpeTopPageStore'
import { FilterBadge } from './FilterBadge'
import { getFilterLabel, copyToClipboard, type FilterSection } from '../utils'

export const DesktopFilterBadges: React.FC = () => {
  const { filterData, removeFilter, generateShareUrl, totalCount, resultCount } = useSearchStore()

  // Collect all active filter badges
  const getActiveFilterBadges = () => {
    if (!filterData) return []

    const badges: Array<{ section: FilterSection; value: string; label: string }> = []

    // Process each filter section
    const sections: FilterSection[] = ['mobilityConditions', 'mealService', 'nurseryFeatures', 'roomType', 'kitchen', 'bathroom']

    sections.forEach((section) => {
      const values = filterData[section] as string[]
      if (values && values.length > 0) {
        values.forEach((value) => {
          const label = getFilterLabel(section, value)
          if (label && !badges.some((b) => b.label === label)) {
            badges.push({ section, value, label })
          }
        })
      }
    })

    return badges
  }

  const activeFilterBadges = getActiveFilterBadges()
  const hasActiveFilters = activeFilterBadges.length > 0

  const handleRemoveFilter = (section: FilterSection, value: string) => {
    removeFilter(section, value)
  }

  const handleShareClick = async () => {
    const shareUrl = generateShareUrl()
    try {
      await copyToClipboard(shareUrl)
      toast.success('Link copied to clipboard!', {
        duration: 3000,
        position: 'top-center',
        style: {
          background: '#10B981',
          color: '#fff',
          padding: '12px 24px',
          borderRadius: '8px',
        },
      })
    } catch (_error) {
      toast.error('Failed to copy link', {
        duration: 3000,
        position: 'top-center',
      })
    }
  }

  // Show active filters with badges
  return (
    <div className="bg-white px-4 shrink-0">
      {hasActiveFilters && (
        <div className="overflow-auto mb-2">
          <div className="flex gap-2 pb-1">
            {activeFilterBadges.map((badge) => (
              <FilterBadge
                key={`${badge.section}-${badge.value}`}
                section={badge.section}
                value={badge.value}
                label={badge.label}
                onRemove={handleRemoveFilter}
              />
            ))}
          </div>
        </div>
      )}

      <div className="flex items-center justify-between py-3">
        <span className="text-sm text-black-900">
          {resultCount} of {totalCount} results
        </span>
        <button className="flex items-center gap-1 text-sm text-gray-600 underline" onClick={handleShareClick}>
          <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 13.3333C4.54167 13.3333 4.14931 13.1701 3.82292 12.8437C3.49653 12.5174 3.33333 12.125 3.33333 11.6667V1.66667C3.33333 1.20833 3.49653 0.815972 3.82292 0.489583C4.14931 0.163194 4.54167 0 5 0H12.5C12.9583 0 13.3507 0.163194 13.6771 0.489583C14.0035 0.815972 14.1667 1.20833 14.1667 1.66667V11.6667C14.1667 12.125 14.0035 12.5174 13.6771 12.8437C13.3507 13.1701 12.9583 13.3333 12.5 13.3333H5ZM5 11.6667H12.5V1.66667H5V11.6667ZM1.66667 16.6667C1.20833 16.6667 0.815972 16.5035 0.489583 16.1771C0.163194 15.8507 0 15.4583 0 15V3.33333H1.66667V15H10.8333V16.6667H1.66667Z"
              fill="#6B7280"
            />
          </svg>
          Filtered shareable link
        </button>
      </div>
    </div>
  )
}
